import React, { useMemo } from 'react';
import styled from 'styled-components';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';
import { withLocalePrefix } from 'shared/utils/translation';
import type { FilterGroup, FilterType } from 'talent_matching/types';
import { useFilterCoverage } from 'talent_matching/hooks/use_filter_coverage';

const t = withLocalePrefix('talent_matching.filters.coverage');

const CountText = styled.span`
  color: ${FullPalette.GREY_800};
`;

const makeCustomLabel = (count: number): React.FC<{ label: string }> => {
  const CustomLabel: React.FC<{ label: string }> = ({ label }) => (
    <span>
      {label}
      <CountText>{` · ${t('candidates_with_value', { count })}`}</CountText>
    </span>
  );
  return CustomLabel;
};

// Options stay selectable — an empty field is a legitimate pick when applicants haven't arrived.
export const useCoverageAnnotatedFilterGroups = (
  groups: FilterGroup[]
): FilterGroup[] => {
  const coverageData = useFilterCoverage();

  return useMemo(() => {
    if (!coverageData) {
      return groups;
    }

    return groups.map((group) => ({
      ...group,
      items: (group.items || []).map((item: FilterType) => {
        const count = coverageData.coverage[item.value];

        if (count === undefined) {
          return item;
        }

        return { ...item, CustomLabel: makeCustomLabel(count) };
      }),
    }));
  }, [groups, coverageData]);
};
